'use client';

import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';
import SearchPopup from './search-popup';

export default function CollapsibleSearch() {
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const handleSearchIconClick = () => {
    setIsSearchOpen(true);
  };

  const handleCloseSearch = () => {
    setIsSearchOpen(false);
  };

  return (
    <>
      <button
        onClick={handleSearchIconClick}
        className="flex h-11 w-11 items-center justify-center text-white transition-colors hover:text-neutral-300"
        aria-label="Search"
      >
        <MagnifyingGlassIcon className="h-6 w-6" />
      </button>

      <SearchPopup isOpen={isSearchOpen} onClose={handleCloseSearch} />
    </>
  );
}
